export const getPaymentMethodsConfig = (value: number, currency: string) => {
  const paymentMethodsConfig = {
    card: {
      showBrandIcon: true,
      hasHolderName: true,
      holderNameRequired: true,
      name: 'Credit or debit card',
      amount: {
        value,
        currency,
      },
      placeholders: {
        cardNumber: '1234 5678 9012 3456',
        expiryDate: 'MM/YY',
        securityCodeThreeDigits: '123',
        securityCodeFourDigits: '1234',
        holderName: 'J. Smith',
      },
    },
  }
  return paymentMethodsConfig
}
